'use client';

import { useMemo } from 'react';
import { useUxpHostInfoContext } from '@frameio/integrations/shared/contexts/UxpHostInfoContext';
import { FeedbackDialog } from '@frameio/shared/components/FeedbackDialog';
import { isUXPEnvironment } from '@frameio/utils/config';

export const FeedbackDialogWithIntegrationsData = () => {
  const uxpHostInfo = useUxpHostInfoContext();
  const hasUxpHostInfo =
    isUXPEnvironment() &&
    Boolean(uxpHostInfo.pluginVersion || uxpHostInfo.schemaVersion);

  const additionalFormData = useMemo(() => {
    if (!hasUxpHostInfo) {
      return undefined;
    }
    return {
      hostAppName: uxpHostInfo.name,
      appVersion: uxpHostInfo.version,
      pluginVersion: uxpHostInfo.pluginVersion,
      uxpVersion: uxpHostInfo.uxpVersion,
      schemaVersion: uxpHostInfo.schemaVersion,
    };
  }, [hasUxpHostInfo, uxpHostInfo]);

  return <FeedbackDialog additionalFormData={additionalFormData} />;
};
